import React, { useEffect, useState } from 'react';
import { PencilSquareIcon, XMarkIcon } from '../../icons';

const SpeakerRenameDialog = ({
  open,
  speakerLabel,
  currentName,
  onClose,
  onSave,
  saving,
  error,
  caseReference,
}) => {
  const [newName, setNewName] = useState('');
  const [applyToCase, setApplyToCase] = useState(false);

  useEffect(() => {
    if (open) {
      setNewName(currentName || speakerLabel || '');
      setApplyToCase(false);
    }
  }, [open, currentName, speakerLabel]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      speakerLabel,
      newName: newName.trim(),
      applyToCase,
    });
  };

  return (
    <div className="md-modal-overlay">
      <div className="md-modal" role="dialog" aria-modal="true" aria-labelledby="rename-speaker-title">
        <div className="md-modal-header">
          <div className="flex items-center gap-2">
            <div className="md-icon-well bg-matdash-primary-subtle text-matdash-primary">
              <PencilSquareIcon className="h-5 w-5" />
            </div>
            <h2 id="rename-speaker-title" className="text-lg font-semibold text-matdash-dark mb-0">
              Rename speaker
            </h2>
          </div>
          <button type="button" onClick={onClose} className="text-matdash-muted hover:text-matdash-dark">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="md-modal-body space-y-4">
          <p className="text-sm text-matdash-muted">
            Rename <span className="font-medium text-matdash-dark">{speakerLabel}</span> for this
            transcript.
          </p>

          <div>
            <label htmlFor="speaker-display-name" className="block text-sm font-medium text-matdash-dark mb-1">
              Display name
            </label>
            <input
              id="speaker-display-name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="e.g. Justice Mensah"
              className="md-form-control w-full"
              autoFocus
            />
          </div>

          {caseReference && (
            <label className="flex items-start gap-2 text-sm text-matdash-muted cursor-pointer">
              <input
                type="checkbox"
                checked={applyToCase}
                onChange={(e) => setApplyToCase(e.target.checked)}
                className="mt-0.5 rounded border-matdash-border text-matdash-primary focus:ring-matdash-primary"
              />
              <span>
                Apply this label to future sessions of case{' '}
                <span className="font-medium text-matdash-dark">{caseReference}</span>
              </span>
            </label>
          )}

          {error && (
            <p className="md-alert md-alert-danger">{error}</p>
          )}

          <div className="flex gap-2 pt-1">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="flex-1 md-btn md-btn-outline disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving || !newName.trim()}
              className="flex-1 md-btn md-btn-primary disabled:opacity-50"
            >
              {saving ? 'Saving…' : 'Save label'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SpeakerRenameDialog;
